import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  message,
  Row,
  Space,
  Spin,
  Switch,
} from "antd";
import React, { useEffect, useState } from "react";
import TextArea from "antd/es/input/TextArea";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import last from "lodash/last";
import map from "lodash/map";
import get from "lodash/get";

import ShiftCompany from "./forms/shiftCompany";
import MultipleEmails from "./forms/multipleEmails";
import SelectTemplates from "./forms/selectTemplates";
import UploadImg from "./forms/uploadImg";
import {
  ADD_COMPANY_SUCCESS,
  UPDATE_COMPANY_SUCCESS,
} from "../../constants/message";
import SingleLocationInput from "../../common/singleLocationInput";
import { addCompany, updateCompany } from "../../redux/actions/companyActions";
import { getLocationInputValue } from "../../utilities/location";
import { fetchScopeNodeHierarchy } from "../../redux/actions/locationActions";
import BreakTimeCompany from "./forms/breakTimeCompany";
import SelectFeaturePermissions from "./forms/selectFeaturePermissions";

const AddEditCompany = ({ toggle, data, refresh, edit, config }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const companyShifts = map(get(data, "company_shifts"), (shift) => {
    return {
      name: get(shift, "name"),
      start: dayjs(get(shift, "start"), "HH:mm"),
      end: dayjs(get(shift, "end"), "HH:mm"),
    };
  });
  const breakTimings =
    get(data, "break_timings.length")>0 &&
    map(get(data, "break_timings"), (break_time) => {
      return {
        name: get(break_time, "name"),
        start: dayjs(get(break_time, "start"), "HH:mm"),
        end: dayjs(get(break_time, "end"), "HH:mm"),
      };
    });

  const onCreateCompany = (payload) => {
    setLoading(true);
    dispatch(addCompany(payload))
      .then((result) => {
        setLoading(false);
        message.success(ADD_COMPANY_SUCCESS);
        refresh();
        toggle();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onUpdateTemplate = (payload) => {
    setLoading(true);
    dispatch(updateCompany(get(data, "id"), payload))
      .then(() => {
        setLoading(false);
        message.success(UPDATE_COMPANY_SUCCESS);
        refresh();
        toggle();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    const location_id = get(
      last(get(values, "location_id", [])).split("-"),
      "1"
    );

    const shifts = map(get(values, "company_shifts"), (shift) => {
      return {
        ...shift,
        start: get(shift, "start").format("HH:mm:ss"),
        end: get(shift, "end").format("HH:mm:ss"),
      };
    });
    const breaks = map(get(values, "break_timings", []), (break_time) => {
      return {
        ...break_time,
        start: get(break_time, "start").format("HH:mm:ss"),
        end: get(break_time, "end").format("HH:mm:ss"),
      };
    });
    const payload = {
      ...values,
      location_id,
      company_shifts: shifts,
      break_timings: breaks,
    };
    if (edit) {
      onUpdateTemplate(payload);
    } else onCreateCompany(payload);
  };

  const getLocation = (locationId) => {
    setLoading(true);
    dispatch(fetchScopeNodeHierarchy("LOCATION", locationId))
      .then((result) => {
        setLoading(false);
        form.setFieldsValue({
          location_id: getLocationInputValue(result),
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getInitialValue = (edit) => {
    const initialData = edit
      ? {
          ...data,
          logo: get(data, "logo.key"),
          company_shifts: companyShifts,
          break_timings:breakTimings,
          feature_permissions: map(
            get(data, "feature_permissions", []),
            "value"
          ),
        }
      : {
          company_shifts: [
            {
              name: null,
              start: null,
              end: null,
            },
          ],
          show_sochiot_logo: true,
        };
    return initialData;
  };
  useEffect(() => {
    if (edit) {
      getLocation(get(data, "location_id"));
    }
  }, [data, edit]);

  return (
    <div className="h-full flex flex-col">
      <Spin spinning={loading}>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onFinishFailed={() => {}}
          scrollToFirstError
          requiredMark={false}
          className="flex-grow overflow-y-auto px-4"
          initialValues={getInitialValue(edit)}
        >
          <Row className="mb-2">
            <Col xl={24} xs={24} sm={24}>
              <SingleLocationInput onChange={(value) => {}} />
            </Col>
          </Row>

          <Space direction="vertical" size="small" className="w-full">
            <Row gutter={20}>
              <Col xl={12} xs={12}>
                <Form.Item
                  label="Company name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input Company name...!",
                    },
                  ]}
                >
                  <Input placeholder={"Company name"} className="input-space" />
                </Form.Item>
              </Col>
              <Col xl={12} xs={12}>
                <Form.Item
                  label="Address"
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "Please input address...!",
                    },
                  ]}
                >
                  <TextArea
                    placeholder={"Address"}
                    className="input-space"
                    rows={2}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col xl={12} xs={12}>
                <MultipleEmails />
              </Col>
              <Col xl={12} xs={12}>
                <Row>
                  <Col xl={12} xs={12}>
                    <Form.Item
                      label="Show sochiot Logo"
                      name="show_sochiot_logo"
                      rules={[
                        {
                          required: true,
                          message: "Please select show sochiot Logo!",
                        },
                      ]}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                  <Col xl={12} xs={12}>
                    <UploadImg form={form} logo={get(data, "logo")} />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={11}>
                <SelectTemplates templates={get(config, "templates")} />
              </Col>
              <Col xs={2} className="flex items-center justify-center">
                <Divider
                  type="vertical"
                  style={{ height: "100%" }}
                  orientation="center"
                  className="mx-auto"
                />
              </Col>
              <Col xs={24} md={11}>
                <SelectFeaturePermissions
                  feature_permissions={get(config, "feature_permissions")}
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={11}>
                <Divider orientation="left" plain>
                  Add Shift
                </Divider>
                <ShiftCompany edit={edit} />
              </Col>
              <Col xs={2} className="flex items-center justify-center">
                <Divider
                  type="vertical"
                  style={{ height: "100%" }}
                  orientation="center"
                  className="mx-auto"
                />
              </Col>
              <Col xs={11}>
                <Divider orientation="left" plain>
                  Add Break
                </Divider>
                <BreakTimeCompany />
              </Col>
            </Row>
          </Space>

          <Form.Item label={null} className="flex justify-end space-x-2">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};

export default AddEditCompany;
